export default class SelectCollapse extends HTMLSelectElement {

    connectedCallback() {

        this.addEventListener("change", this.filterItems);

        this.filterItems();
    }

    disconnectedCallback() {

        this.removeEventListener("change", this.filterItems);

    }

    filterItems = (e) => {
        let selector = "";

        for (const selectedOption of this.querySelectorAll('option:checked')) {
            selector += `[data-collapse-${this.dataset.collapseGroup}~=\"${selectedOption.value}\"]`;
        }

        this.collapseElements.forEach(el => {
            if (!selector) {
                el.classList.remove("d-none");
            }
            else {
                el.classList.toggle("d-none", !el.matches(selector));
            }
        });
    }

    get collapseElements() {
        return this.targetElement.querySelectorAll(`[data-collapse-${this.dataset.collapseGroup}]`);
    }

    get targetElement() {
        return document.querySelector(this.dataset.target) || document;
    }
}

customElements.define('select-collapse', SelectCollapse, { extends: 'select' });